/**
 * Created by mykurisu on 2017/6/23.
 */
import React from 'react'
import {connect} from 'react-redux'
import {browserHistory} from 'react-router'
import axios from 'axios'
import {LoadMore} from 'react-weui'
import {WKCurrencyItem} from '../wk'
import {isTouchBottom} from "../../utils";
import '../../styles/liveroom/LiveroomListArea.css'
import IconCreate from '../../images/liveroom/icon-create.png'

class LiveroomLectureListArea extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            offset: this.props.next_offset,
            ended: false
        };
        this.handleLoadMore = this.handleLoadMore.bind(this);
    }

    componentDidMount() {
        this.scroll_method = () => {
            let shouldGet = isTouchBottom(30)
            if (shouldGet && this.props.has_more && !this.state.ended){
                if (!this.state.loading){
                    let params = {
                        limit: 10,
                    };
                    params.offset = this.state.offset;

                    this.setState({
                        loading: true
                    });

                    const {liveroom_id} = this.props;

                    axios.get(`/api/liveroom/${liveroom_id}/lecture_list_n`, {params: params}).then((response) => {
                        const {next_offset, has_more, lectures} = response.data.data;
                        if (response.data.code === 0) {
                            this.setState({
                                loading: false,
                                offset: next_offset,
                                ended: !has_more
                            });

                            this.props.dispatch({
                                type: 'LIVEROOM_LECTURES_APPEND',
                                payload: {
                                    lectures: lectures
                                }
                            })
                        }
                    });
                }
            }
        };

        window.addEventListener('scroll',this.scroll_method);
    }

    componentWillUnmount (){
        this.scroll_method && window.removeEventListener('scroll',this.scroll_method);
    }

    handleLoadMore() {
        let params = {
            limit: 10,
        };
        params.offset = this.state.offset;

        this.setState({
            loading: true
        });

        const {liveroom_id} = this.props;

        axios.get(`/api/liveroom/${liveroom_id}/lecture_list_n`, {params: params}).then((response) => {
            const {next_offset, has_more, lectures} = response.data.data;
            if (response.data.code === 0) {
                this.setState({
                    loading: false,
                    offset: next_offset,
                    ended: !has_more
                });

                this.props.dispatch({
                    type: 'LIVEROOM_LECTURES_APPEND',
                    payload: {
                        lectures: lectures
                    }
                })
            }
        });
    }

    renderLoadStyle() {
        const {has_more} = this.props;
        const {ended, loading} = this.state;
        if (has_more) {
            if (!ended) {
                if (!loading) {
                    return (
                        <div className="weui-padding text-center liveroom-loadmore-container">
                            <a className="block text-center liveroom-loadmore">
                                查看更多
                            </a>
                        </div>
                    )
                } else {
                    return (
                        <LoadMore loading className="liveroom-page-container_loading">正在加载</LoadMore>
                    )
                }
            } else {
                return true
            }
        } else {
            return true
        }
    }

    render() {
        const {classList, lecture, role} = this.props;
        return (
            <div className="liveroom-page-container" style={{marginTop: '10px'}}>
                {role.is_manager ?
                    <div className="liveroom-page-titlebar">
                        <span className="liveroom-page-titlebar-title" onClick={() => location.assign(`/liveroom/${this.props.liveroom_id}/edit/lecture`)}>课程（{lecture.total_count}）</span>
                        <img className="liveroom-page-create liveroom-page-create__lecture" src={IconCreate} onClick={() => location.assign(`/liveroom/${this.props.liveroom_id}/lecture/create`)}/>
                    </div>
                    :
                    <div className="liveroom-page-titlebar">
                        <span className="liveroom-page-titlebar-title">课程（{lecture.total_count}）</span>
                    </div>
                }
                <div>
                    {classList.map((list) => <WKCurrencyItem key={list.id} content={list} type={'lecture'} role={role} relayShow={role.is_manager}/>)}
                </div>
                {this.renderLoadStyle()}
            </div>
        )
    }

}

export default connect(state => ({
    lecture: state.liveroom.lecture,
    has_more: state.liveroom.lecture.has_more,
    classList: state.liveroom.classList,
    liveroom_id: state.liveroom.liveroom.id,
    next_offset: state.liveroom.lecture.next_offset,
    role: state.liveroom.role,
}))(LiveroomLectureListArea)


// WEBPACK FOOTER //
// ./src/components/liveroom/LiveroomLectureListArea.js